var render = function render(){var _vm=this,_c=_vm._self._c;return _c('help-info-wrapper',{staticClass:"warp",attrs:{"info":_vm.helpData,"service-name":_vm.serviceName},on:{"update:info":function($event){_vm.helpData=$event}}},[[_c('v-row',{attrs:{"no-gutters":""}},_vm._l((_vm.categories),function(item,i){return _c('v-col',{key:i,staticClass:"py-6 px-md-6",attrs:{"cols":"12","md":"6"}},[_c('cat-card',{attrs:{"item":item}},[[_c('help-info',{staticClass:"buttoninfo",style:({
                opacity: item.comingSoon ? 0.2 : 1,
                'pointer-events': item.comingSoon ? 'none' : 'auto',
                top: '46%',
                boxShadow: 'none',
                left: '4%',
                position: 'relative',
              }),attrs:{"element-name":`${_vm.serviceName}-${_vm.componentName}-catBusinessShop-${item.route}`,"service-name":_vm.serviceName,"help-data":_vm.helpData,"label":`${item.name}`}})]],2)],1)}),1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }